//Copyright © Northstar Travel Media, LLC. All Rights Reserved - code may not be reused in whole or in part without written consent- removal of this section consitutes a copyright violation
function myrnd(){return Math.round(Math.random() * 10000000000)}
function appndURL(u,a){if (u.indexOf('?')==-1){u = u + '?'}else{u = u + '&'};u = u + a;return u}
function donothing(){}
function disablelink(a){a.disabled=true;a.onclick=dontdo;a.href=''}
function enablelink(a,href){a.disabled=false;a.onclick='';a.href = href;}
function dontdo() { return false }
function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
//do this to get referer on window.location calls
function winloc(u) { window.location = u }
function refreshwin(c) {
     if (c == undefined) { c = true }
     var u = window.location.href.split('#')[0]
     if (c) { u = window.location.pathname }
     var n = new String(u).length
     var l = new String(u).substring(n-1, n+1)
     if (l.toString() == "#") {u = new String(u).substring(0, n - 1)}
     window.location = u
 }
function _newopt(t, v, s) { var optn = document.createElement("OPTION"); optn.text = t; optn.value = v; optn.selected = v == s; return optn }
function _newopthtml(t, v, s) { return '<option value="' + v + '"' + (v == s ? " selected" : "") + '>' + t + '</option>' }
function showError(error) { var stackTrace = error.get_stackTrace(); var message = error.get_message(); var statusCode = error.get_statusCode(); var exceptionType = error.get_exceptionType(); var timedout = error.get_timedOut(); console.log("-" + message + "-"); if (message == "error 0") { return; } alert(message); }

function serviceProxy(serviceUrl) {
    var _I = this;
    this.serviceUrl = serviceUrl;
    this.invoke = function(method, data, callback, error) {
        var json = JSON.stringify(data);
        var url = _I.serviceUrl + method;
        $.ajax({
            url: url,
            data: json,
            type: "POST",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function(data) {
                if (data.d) { data = data.d }
                if (!callback) return; callback(data); return;
            },
            error: function(err) { if (!error) return; error(err); return; }
        });
     }
 }
function AjaxFailed(result) { if (result.status == 0) { return; } alert(result.status + ' ' + result.statusText); }
DynaProxy = new serviceProxy("/Dyna.asmx/");

// **************  START PAGE TRACKING ********************************************************  
function myTrackPageView(u,r,a){
    if (a == undefined) { a = "" }
    var orgu = u; qs = ""; qs2 = "";
    if (u.indexOf('?') != -1) { qs = u.substring(u.indexOf('?') + 1); qs2 = "?" + qs }
    try { initTracking(); u = s.prop1 + "/AJAX/" + a; } catch (e) { };
    try { pageTracker._trackPageview(u + qs2); } catch (e) { };
    try { s.prop70 = a; s.prop1 = u; s.prop2 = qs; s.t(); } catch (e) { };
//    if (r) { window.setTimeout(rotateads, 1000) }
}

function myTrackEvent(category, action, label, value) {
    try {
        if (ga) { ga('send', 'event', 'Ajax Actions', category, action); }
    } catch (e) { }
}
// **************  END PAGE TRACKING ********************************************************

function isDate(dateStr) {
    var datePat = /^(\d{1,2})(\/|-)(\d{1,2})(\/|-)(\d{4})$/;
    var matchArray = dateStr.match(datePat); // is the format ok?
    return matchArray != null
}

function isTime(timeStr) {
    var datePat = /^\d{1,2}:\d{2}([ap]m)?$/;
    var matchArray = timeStr.match(datePat); // is the format ok?
    return matchArray != null
}

function DateAdd(timeU,byMany,dateObj) {
	var millisecond=1;
	var second=millisecond*1000;
	var minute=second*60;
	var hour=minute*60;
	var day=hour*24;
	var year=day*365;

	var newDate;
	var dVal=dateObj.valueOf();
	switch(timeU) {
		case "ms": newDate=new Date(dVal+millisecond*byMany); break;
		case "s": newDate=new Date(dVal+second*byMany); break;
		case "mi": newDate=new Date(dVal+minute*byMany); break;
		case "h": newDate=new Date(dVal+hour*byMany); break;
		case "d": newDate=new Date(dVal+day*byMany); break;
		case "y": newDate=new Date(dVal+year*byMany); break;
	}
	return newDate;
}

function AND(a, b) {
    var result = 0;
    var x = binaryArray(parseInt(a));
    var y = binaryArray(parseInt(b));
    var biggerArray = (x.length >= y.length) ? x : y;
    var smallerArray = (biggerArray == x) ? y : x;
    var len = biggerArray.length;
    for (var i = 0; i < len; i++) {
        biggerArray[i] = (biggerArray[i] & smallerArray[i]) ? 1 : 0;
        result += biggerArray[i] * Math.pow(2, i);
    }
    return result;
}

function binaryArray(num) {
    var arr = new Array();
    var div;
    var mod;
    var n = num;
    var count = 0;
    do {
        mod = n % 2;
        n = parseInt(n / 2);
        arr[count++] = mod;
    } while (n > 0)
    return arr;
}

function isScrolledIntoView(elem) { var docViewTop = $(window).scrollTop(); var docViewBottom = docViewTop + $(window).height(); var elemTop = $(elem).offset().top; var elemBottom = elemTop + $(elem).height(); return ((elemBottom >= docViewTop) && (elemTop <= docViewBottom) && (elemBottom <= docViewBottom) && (elemTop >= docViewTop)); }

function pushLoadMore(url, p) {
    var title = document.title;
    if (p != undefined && p != "" && p != "1") { if (title.indexOf("| Page ") > 0) { title = title.substring(0, title.indexOf("| Page "))  + "| Page " + p; } else { title += " | Page " + p; } }
    var stateObj = { Title: title };
    history.pushState(stateObj, title, url);
    document.title = title;
}

$(function () {
    $(document).on("click", ".show-more", function () {
        var req = new Object;
        var e = $(this);
        req.PageKey = e.attr("_p");
        req.WidgetId = e.attr("_wid");
        req.PageNumber = e.attr("_n");
        if ($(this).is("[_u1]")) { req.User1 = $(this).attr("_u1"); }
        if ($(this).is("[_u2]")) { req.User2 = $(this).attr("_u2"); }
        if ($(this).is("[_u3]")) { req.User3 = $(this).attr("_u3"); }
        if ($(this).is("[_u4]")) { req.User4 = $(this).attr("_u4"); }
        if ($(this).is("[_u5]")) { req.User5 = $(this).attr("_u5"); }
        if ($(this).is("[_u6]")) { req.User6 = $(this).attr("_u6"); }
        if ($(this).is("[_ukw]")) { req.TopicKeyword = $(this).attr("_ukw"); }
                
        pushLoadMore(e.attr("href"), e.attr("_n"));

        var DTO = { 'req': req }
        DynaProxy.invoke("PageContentList", DTO, function (data) {
            var e = $(".show-more").parents(".col-12")
            $(e).before(data);
            $(e).remove();           
        }, AjaxFailed);        
        return false;
    })

    $(document).on("click", ".vid-lib-type input", function () {
        var req = new Object;
        var e = $(".pnl-vlib");
        req.PageKey = e.attr("_p");
        req.WidgetId = e.attr("_wid");
        req.PageNumber = 1;
        req.User1 = $(".vid-lib-type").val();
        var DTO = { 'req': req }
        DynaProxy.invoke("PageContentList", DTO, function (data) {
            var e = $(".pnl-vlib")
            $(e).html(data);
        }, AjaxFailed);
        return false;
    })

    $(document).on("click", ".vlib-show-more", function () {
        var req = new Object;
        var e = $(this);
        req.PageKey = e.attr("_p");
        req.WidgetId = e.attr("_wid");
        req.PageNumber = e.attr("_n");
        req.User1 = $(".vid-lib-type").val(); 
        pushLoadMore(e.attr("href"), e.attr("_n"));
        var DTO = { 'req': req }
        DynaProxy.invoke("PageContentList", DTO, function (data) {
            var e = $(".vlib-show-more")
            $(e).parent().before(data);
            $(e).remove();
        }, AjaxFailed);
        return false;
    })

    $(document).on("click", ".v-show-more", function () {
        var req = new Object;
        var e = $(this);
        req.PageKey = e.attr("_p");
        req.WidgetId = e.attr("_wid");
        req.PageNumber = e.attr("_n");
        if ($(this).is("[_u1]")) { req.User1 = $(this).attr("_u1"); }
        if ($(this).is("[_u2]")) { req.User2 = $(this).attr("_u2"); }
        if ($(this).is("[_u3]")) { req.User3 = $(this).attr("_u3"); }
        if ($(this).is("[_u4]")) { req.User4 = $(this).attr("_u4"); }
        if ($(this).is("[_u5]")) { req.User5 = $(this).attr("_u5"); }
        if ($(this).is("[_u6]")) { req.User6 = $(this).attr("_u6"); }
        if ($(this).is("[_ukw]")) { req.TopicKeyword = $(this).attr("_ukw"); }
        pushLoadMore(e.attr("href"), e.attr("_n"));
        var DTO = { 'req': req }
        DynaProxy.invoke("PageContentList", DTO, function (data) {
            var e = $(".v-show-more")
            $(e).before(data);
            $(e).remove();
        }, AjaxFailed);
        return false;
    })

    //search
    $(document).on("click", ".jq-page-search-btn2",
        function () {            
            doPagedListNav(1, true);
            return false;
        });

	$(document).on("click", ".jq2-page", function () {
    	var req = new Object;
		req.PageKey = $(this).attr("_p")
		req.WidgetId = $(this).attr("_wid")
		req.PageNumber = $(this).attr("_pg")
		if ($(this).is("[_u1]")) { req.User1 = $(this).attr("_u1"); }
		if ($(this).is("[_u2]")) { req.User2 = $(this).attr("_u2"); }
		if ($(this).is("[_u3]")) { req.User3 = $(this).attr("_u3"); }
		if ($(this).is("[_u4]")) { req.User4 = $(this).attr("_u4"); }
		if ($(this).is("[_u5]")) { req.User5 = $(this).attr("_u5"); }
		if ($(this).is("[_u6]")) { req.User6 = $(this).attr("_u6"); }
		if ($(this).is("[_ukw]")) { req.TopicKeyword = $(this).attr("_ukw"); }
		$(".search-list-results").css({ opacity: 0.3 });
		var DTO = { 'req': req }
		DynaProxy.invoke("PageContentList", DTO, function (data) {
		    $(".search-list-results").html(data).css('opacity', '');
		    if (!isScrolledIntoView($('#list-top'))) { $(document).scrollTop($('#list-top').offset().top - 120) }
		}, AjaxFailed)

		return false;
	})

	function doSearch(pgNum, more) {
	    if (!more) { $(".search-list-results").css({ opacity: 0.3 }); }

	    var req = new Object;
	    req.PageKey = $(".search-list-results").attr("_p")
	    req.WidgetId = $(".search-list-results").attr("_wid")
	    req.PageNumber = pgNum;
	    req.User1 =$(".search-list-term").val(); //term
	    req.User2 = getFacetCheckedList("dest"); //destination 
	    req.User3 = getFacetCheckedList("travtype"); //traveltype
	    req.User4 = getFacetCheckedList("date"); //date
	    req.User5 = (window.location.href.indexOf("&debug=1") > 0 ? "1" : "0")

	    var DTO = { 'req': req }
	    DynaProxy.invoke("PageContentList", DTO, function (data) {
	        if (more) { var e = $(".search-show-more").parent(); $(e).before(data); $(e).remove(); }
	        else {
	            $(".search-list-results").html(data).css('opacity', '');
	            if (!isScrolledIntoView($('#list-top'))) { $(document).scrollTop($('#list-top').offset().top - 120) }
	         }	        
	    }, AjaxFailed)
	
    }
    
	$(document).on("click", ".search-show-more", function () {
	    doSearch($(this,false).attr("_n"),true);
	    return false;
    })
    
	$(document).on("click", ".search-page", function () {
	    doSearch($(this).attr("_pg"), false)
	    return false;
    })
    
	$(document).on("click", ".search-filter-list-item", function () {
	    var parent = $(this).parents(".filter-facet-list")
	    if ($(parent).hasClass("issingle")) {
            if ($(this).prop('checked')) {//uncheck all other boxes
	            var sVal = $(this).attr('value');
	            $(parent).find("*:checkbox:checked").map(function () {if (sVal !=$(this).attr('value')) {$(this).prop('checked', false)}})
	        }
	    }
	    $(parent).parent().click();
	    doSearch(1, false)
	})

	function getFacetCheckedList(id) {
	    var list = $("#filter-list-" + id);
	    var bSingle = $(list).hasClass("issingle")
	    var opts = "";
	    list.find("*:checkbox:checked").map(function () { opts = opts + $(this).val() + ","; if (bSingle) { return opts;}})
	    return opts;
	}

	var sSearchURL = "/Search";
    function doSiteSearch(q) {
        if (q == null || q.toString().length == 0) {
            return;
        }
	    var u = sSearchURL + (q != "" ? "?q=" + q : "");
	    window.location = u;
    }
    
    $("button.btn-search").click(function () {
        doSiteSearch($(this).parents(".search-form").find("input").val());
		return false;
    });
    
    $(".search-form").find("input").keypress(function (event) {
	    if (event.which == 13) {
	        doSiteSearch($(this).val());
	        event.preventDefault();
	    }
    });

    $(".drp-city-list").on('change', function (ev) {
        $("#tab-content-hotel-destination .tab-pane").removeClass("show").removeClass("active")
        $("#tab-content-hotel-destination #panel-city-" + $(this).val()).addClass("show").addClass("active")

    })
});

//comments
$(document).on('click', '.jq-comment-post', function (e) {
    var parent = $(this).parents(".pg-comments")
    var email = parent.find("#comment-email").val();
    var comment = parent.find("#comment-copy").val();
    parent.find(".commentresult").html("Sending your feedback...");
    if (!validateEmail(email)) {
        parent.find(".commentresult").html("Please enter a valid email address.").show();
        return false;
    }
    if (comment.length ==0) {
        parent.find(".commentresult").html("Please enter your comments above.").show();
        return false;
    }
    if (comment.length < 10) {
        parent.find(".commentresult").html("Your comment above must be at least 10 characters .").show();
        return false;
    }

    var req = new Object;
    req.PageKey = $(this).attr("_p");
    req.WidgetId = $(this).attr("_wid");
    req.User1 = email;
    req.User2 = comment;
    var DTO = { 'req': req };
    DynaProxy.invoke("PageContentList", DTO, function (data) {
        parent.find(".commentresult").html(data);
        parent.find("#comment-email").val("");
        parent.find("#comment-copy").val("");

    }, AjaxFailed);
    e.preventDefault();
});

function closeme() { $.fancybox.close(); }

function Has3rdPartyCookie() { return getCookie(thirdpartycookiename) == "1"; }

function Create3rdPartyCookie() { setCookie(thirdpartycookiename, 1, 3650); }

function IsLoc3rdParty(locVal, isNewsletter) {
    var rc = false;
    if (!Has3rdPartyCookie()) {
        console.log(locVal)
        var isDownload = false;
        if ($('#divType').length > 0) { isDownload=true }
        if (isNewsletter) {
            if (($('#divPlanner').length==0) & (locVal == "01" || locVal == "02" || locVal == "03" || locVal == "04")) { $(".pnlThirdParty").show();rc=true }
            else { $(".pnlThirdParty").hide(); }
        }
        else {
            if (locVal == "" || locVal == "111768") { $(".pnlThirdParty").hide(); }
            else {
                if (isDownload) {
                    if ($('#divType').html() == "Editorial")
                    { $(".pnlThirdParty").show(); rc = true; }
                    else
                    { $(".pnlThirdParty").hide(); }
                }
                else {
                    if ($('#divSprType').html() != "SPR" && $('#divSprType').html() != "WBN") {
                        $(".pnlThirdParty").show(); rc = true
                    }
                }
            }
        }
    }
    else {
        if ($(".thirdpartyList.profile").length == 0) //always show in profile 
        { $(".pnlThirdParty").hide(); }
        else
        { $(".pnlThirdParty").show(); }
    }
    return rc;
}

jQuery(document).ready(function ($) {
    if ($(".RegCountryList").length > 0) { IsLoc3rdParty($(".RegCountryList").val(), false); }   
    if ($("#loc").length > 0) { IsLoc3rdParty($("#loc").val(), true); }

    $(document).on("change", "#loc", function () {
        if ($(this).val() != "") { IsLoc3rdParty($(this).val(), true) }
    });

    $(document).on("change", ".RegCountryList", function () {         
        if ($(this).val() != "")  { IsLoc3rdParty($(this).val(),false)}	          
    });

    $(document).on('click', '.jq-sort a', function () {
        var bHasClass = $(this).hasClass("active");
        $(".jq-sort").find("a").removeClass("active");
        if (!bHasClass) { $(this).addClass("active"); }
        doPagedListNav(1, true);
        return false;
    });

    $(document).on("click", ".jq-show-more",  function () {
	    doPagedListNav($(this).attr("_n"), false);
	    return false;
	});

	$(".results-page").find('input[type="checkbox"]').change(function() {
	    $(".jq-page-search-btn2").click();
	    var a = $(".results-page").find(".dropdown-menu.show");
	       
	    if (a) {
	        a.removeClass("show");
	    }
	    var b = a.parent().find("div[aria-expanded='true']");
	    b.attr("aria-expanded", "false");
	});
	$(".results-page").find("input").keypress(function (event) {
	    if (event.which == 13) {
	        $(".jq-page-search-btn2").click();
	       
	        event.preventDefault();
	    }
	});

    $(document).on("click", ".btn-newsletter", function () {
	    var elePar = $(this).parents(".jq-Newsletter")
	    elePar.find(".error").hide()
        var opts = ""; var desc = ""; var type = "newsletter";         
	    var e = elePar.find(".form-control").val();
	    if (!validateEmail(e)) {
	        elePar.find(".error").html("Please enter a valid email address.").show();
	        return false;
	    }
	    if (elePar.find("*:checkbox").length > 0) {
	        elePar.find("*:checkbox:checked").map(function () {
                desc= desc + $(this).next().html() + "<br/>"
	            opts = opts + $(this).val() + "|"
	        })
	        if (opts == '') {
	            elePar.find(".error").html("Please select one or more newsletters to subscribe to.").show();
	            return false;
	        }
	    }
	    var loc = ""
	    if (elePar.find("#loc").length > 0) { loc = elePar.find("#loc").val();}
	    if (loc==""){
	        elePar.find(".error").html("Please select your location.").show();
	        return false;
        }
        if ($('#Btnterms').length > 0) {
            if ($("#Btnterms").is(":checked") == false) {
                elePar.find(".error").html("Please accept Terms and Conditions and Privacy Policy.").show();
                return false;
            }
        }

        var plannerType = ""
        
        if (elePar.find("#plannertype").length > 0) {
            plannerType = elePar.find("#plannertype").val();
            if (plannerType == "") {
                elePar.find(".error").html("Please select your Planner Type.").show();
                return false;
            }
        }

        if ($(this).parents(".NewsletterTopic").length > 0) {
            type = "topic";
            if ($('.form-copy input:checked').length == 0) {
                elePar.find(".error").html("Please agree to Terms and Conditions and Privacy Policy.").show();
                return false;
            }
        }

	    if (IsLoc3rdParty(loc,true)){
	        if ($('.thirdpartyList input:checked').length == 0) {
	            elePar.find(".error").html("Please select Yes or No below.").show();
	            return false;
	        }

	        var  opt=$('.thirdpartyList input:checked').val();
	        if (opt== "1") {opts = opts + thidpartyoptin + "|"; }
	        else {opts = opts + thidpartyoptout + "|"; }          
	        Create3rdPartyCookie(); 
	    }        
        showNewsletterOptin(e, opts, loc, desc, plannerType, "", "", "", window.location, type)
	    if ($('.thirdpartyOpt').length > 0)
	    {
	        $('.thirdpartyOpt').hide();
	    }
        return false;
    })

	$(".jq-Newsletter").find("input").keypress(function (event) {
		if (event.which == 13) {
		    $(this).closest(".jq-Newsletter").find("button").click();
		    event.preventDefault();
		}
	});

	setupForm();
	initFilteredList();
});

function validateEmail(email) { var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\ ".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA -Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; return re.test(email); }

function setupForm() {
	setupAdaptive();
	$(".adaptive").change(function () { setupAdaptive() })
};

function setupAdaptive() {
	$(".adaptive").each(function () {
	    if ($(this).val() == "") { $(this).removeClass("filled"); } else { $(this).addClass("filled"); }  
	});
}

// **************   FILTERED LISTS ********************************************************
function refreshFilteredList(pg, more) {
    if (!more) { $(".filter-list-results").css({ opacity: 0.3 }); }
	var req = new Object;
	req.PageKey = $(".filter-list-results").attr("_p");
	req.WidgetId = $(".filter-list-results").attr("_wid");
	req.PageNumber = pg;
	req.User1 = $('.filter-list').find(".active").attr("_val");
	var DTO = { 'req': req };
	DynaProxy.invoke("PageContentList", DTO, function (data) {
	    if (more) { var e = $(".show-filtered-more").parent(); $(e).before(data); $(e).remove(); }
	    else {
	        $(".filter-list-results").html(data).css('opacity', '');
	        if (!isScrolledIntoView($('#list-top'))) { $(document).scrollTop($('#list-top').offset().top - 120) }
	    }
	}, AjaxFailed);
}

function HasRegOverlayCookie(cID) { return getCookie(cID) == "1"; }

function showGatedLoginRegOverlay(cID) {
    if (!HasRegOverlayCookie("Reg" + cID + "Overlay")) {
        var url = window.location.pathname;
        var isSpsr = ""
        var spsrId = ""
        if ($('.divSpr').html() == "SPR") { isSpsr = "&type=SPR"; }
        if ($('.divSpr').html() == "WBN") { isSpsr = "&type=WBN"; }
        if ($('.divSprId').html().length != 0) {
            spsrId = "&sponsor=" + $('.divSprId').html();
            $('#signupModal2').find('iframe').css('height', '300px');
        }
        if (cID.length != 0) { cID="&cID=" + cID}
        $("#signupModal2").find("iframe").attr("src", "/user/widgets/register/?returl=" + escape(url) + isSpsr + spsrId + cID)
        $('#signupModal,#signupModal2').modal('show')
    }
    
    $("#signupModal2").on("hidden.bs.modal", function () {
        if ($("iframe").contents().find("#Button_TravelBack").length == 0) {
            window.location = "/"
        }
    })
}

function closeRegOverlay() {
    $('#signupModal,#signupModal2').modal('hide')
    window.location = "/";
}

function scrollModalToTop() {
    $('#signupModal,#signupModal2').scrollTop(0);
}

function initFilteredList() {
    $(".filter-list").find("a").on("click", function () {
        var bHasClass = $(this).parent().hasClass("active")
        $(".filter-list").find("li").removeClass("active");
        if (!bHasClass) { $(this).parent().addClass("active"); }        
        refreshFilteredList(1, false); return false;
    });
    $(document).on("click", ".show-filtered-more", function () { refreshFilteredList($(this).attr("_n"), true); return false; });
}
// **************  END FILTERED LISTS ********************************************************

/*** Reg ***/
function getreturl() { if (typeof returl == "undefined") { return ""; } else { return returl; } }
$(document).ready(function () {
    /*** show checkbox for topic newsletter widget ***/
    if ($('.NewsletterTopic').length > 0) {
        $('#Btnterms').show();
    }
    else { $('#Btnterms').hide(); }

    initnewslettertracking();
    //$(".fancy-option").fancybox({ 'width': '70%', 'height': '50%', 'autoScale': false, 'transitionIn': 'none', 'transitionOut': 'none', 'type': 'iframe' });
    $(".over-login").click(function () { showLogin(); return false; });
    $(".over-reg").click(function () {
        if (hasOmni()) { evlink($(this), $(this).attr("_Event"), 'Register', 71, window.location, 6, $(this).attr("_Source")) }
        showRegister(); return false;
    })

    $(document).on('click', '.newsletter-example', function (e) {
        modalMediaOpen();
        var mediaCarousel = $('#modal-video').find('.modal-body');
        $(mediaCarousel).html("<img src='" + $(this).attr("href") + "'/>");
        $('#modal-video').modal('show');
        e.preventDefault();

    });
    // resize function
});

function doPagedListNav(pgNum, replace) {
    var l = $(".jq2-list")
    $(l).css({ opacity: 0.3 })
    var req = new Object;
    req.PageKey = $(l).attr("_p");
    req.WidgetId = $(l).attr("_wid");
    req.PageNumber = pgNum

    if ($(".results-page").find(".jq-page-search").length > 0) {
        if ($(".results-page").find(".jq-page-search").val() == "")
        {
            var e = $(".jq2-list");
            $(e).html("<div class='search-page-util row'><div class='search-page-util--count col-8'>You have entered no keyword(s)...</div></div>");
            $(e).css('opacity', '');
            return;
        }
        else {
            req = buildSiteSearch(req)
        }
    } else {
        if ($(this).is("[_u1]")) { req.User1 = $(this).attr("_u1"); }
        if ($(this).is("[_u2]")) { req.User2 = $(this).attr("_u2"); }
        if ($(this).is("[_u3]")) { req.User3 = $(this).attr("_u3"); }
        if ($(this).is("[_u4]")) { req.User4 = $(this).attr("_u4"); }
        if ($(this).is("[_u5]")) { req.User5 = $(this).attr("_u5"); }
        if ($(this).is("[_u6]")) { req.User6 = $(this).attr("_u6"); }
        if ($(this).is("[_ukw]")) { req.TopicKeyword = $(this).attr("_ukw"); }
    }
    var u = "/Search?q=" + encodeURIComponent(req.User1);
    if (pgNum > 1) { u += "&pg=" + pgNum; }
    pushLoadMore(u, pgNum);
    var DTO = { 'req': req }
    DynaProxy.invoke("PageContentList",
        DTO,
        function(data) {
            var e = $(".jq2-list");
            if (replace) {
                $(e).html(data)
                if (!isScrolledIntoView($('#list-top'))) {
                    $(document).scrollTop($('#list-top').offset().top - 70);
                }

                $(e).css('opacity', '');
            } else {
                $(e).css('opacity', '');
                var e = $(".jq-show-more").parents(".col-12");
                $(e).before(data);
                $(e).remove();
            }
        },
        AjaxFailed);
}

function buildSiteSearch(req) {
    if ($(".results-page").length > 0) {
        req.User1 = $(".results-page").find(".jq-page-search").val();
    }
    req.User2 = getFilterCheckedList("type"); //type
    req.User4 = getFilterCheckedList("auth"); //author    
    req.User3 = getFilterCheckedList("date"); //date    
    if ($(".jq-sort").length > 0 && $(".jq-sort").find("a.active")) { req.User5 = $(".jq-sort").find("a.active").attr("_source"); }
    req.User6 = (window.location.href.indexOf("&debug=1") > 0 ? "1" : "0");
    return req;
}

function getFilterCheckedList(id) {
    var list = $("#filter-" + id); 
    var bSingle = $(list).find(".form-group-list").hasClass("issingle");
    var opts = "";
    list.parent().find("*:checkbox:checked").map(function () { opts = opts + $(this).val()+ "," ; if (bSingle) { return opts; } })
    return opts;
}

function isiniframe() { return ((window.location != window.parent.location) ? true : false); }

function LinkToPage(u, e, ret) {
    if (e != undefined && e != "") { u = appndURL(u, "email=" + escape(e)) }
    if (ret == undefined) { ret = "" }
    if (ret == "") { ret = getreturl() }
    if (ret != "") { u = appndURL(u, "returl=" + escape(ret)) }

    window.location.href = u;
}

function showLogin(e, r) { LinkToPage("/User/Widgets/Login/", e, window.location.pathname); }

function showRegister(e, r) { LinkToPage("/User/Widgets/Register/", e, window.location.pathname); }

function showPassword(e, r) { LinkToPage("/User/Widgets/Password/", e, window.location.pathname); }

function showNewsletterOptin(e, opts, loc, desc,plannerType,nameFirst,nameLast,state, source,type) {
    var DTO = { 'e': e, 'o': opts, 'l': loc, 'p': plannerType, 'nf': nameFirst, 'nl': nameLast,'s':state,'t':type
        }
    DynaProxy.invoke("SaveOptin", DTO, function (data) {
        if (data!="x"){
            // Copy values to box and reveal modal
            var newsConfirmModal;
            if (type=="topic") {
                newsConfirmModal = $('#regionConfirmation');
                $('.confirm-regions', newsConfirmModal).html(desc);
                $('.confirm-region-msg', newsConfirmModal).html(data); 
            }
            else {
                newsConfirmModal = $('#newsletterConfirmation');
                $('.confirm-newsletters', newsConfirmModal).html(desc);
                $('.confirm-newsletter-msg', newsConfirmModal).html(data);
              }
             
        newsConfirmModal.modal('show');
        } else {
            if (type == "topic") {
                  alert('There was an error saving your options.  Please contact us for assistance.') 
            }
            else { alert('There was an error saving your newsletter options.  Please contact us for assistance.')}
        }
    
    }, AjaxFailed)
}

function hasGA() { return !(typeof _qaq === 'undefined') }

function hasOmni() { return !(typeof s === 'undefined') }

//start newsletter tracking 
Array.prototype.remove = function (from, to) {
    var rest = this.slice((to || from) + 1 || this.length);
    this.length = from < 0 ? this.length + from : from;
    return this.push.apply(this, rest);
};

var newsletterOptions = new Array();

function nwsltrlabel() { var opts = newsletterOptions.join(); if (hasOmni) { opts = opts + ' | ' + s.prop9; }; return opts; }

function initnewslettertracking() {
    $('.jq-Newsletter input[type="checkbox"]').click(function () {
        if ($(this).prop('checked')) { newsletterOptions.push($(this).next().html()); }
        else { newsletterOptions.remove(newsletterOptions.indexOf($(this).next().html())); }
    });
}
//end newsletter tracking 

var sVenueACHotelURL = ''; var sVenueSearchURL = '/Meeting-Event-Venues/Venue-Search'; var sVenueSearchURL2 = '/Meeting-Event-Venues/Search'; var venue_search_chain_keys='';

$(function () {
    $('.hotel-ac').initAutoSearch({ 'searchType': 'HOT', 'serviceURL': '/AutoComplete.asmx', 'searchURL': sVenueSearchURL2, 'parentSelector': '' });

    $(".hotel-ac button[type='submit']").click(function () {
        var txtVal = $(".hotel-ac input:text").val();
        var u = "";
        if (sVenueACHotelURL != '') { u = sVenueACHotelURL; sVenueACHotelURL = ''; }
        else {
            if (txtVal != "") { u = sVenueSearchURL + "?pst=" + escape(txtVal) + "&typ=HOT"; }
            else { u = sVenueSearchURL2 + "?typ=HOT"; }
        }       
        if (u != '') { u = appndVSrchParms(u); winloc(u);}
    });

    $("#find-venue-submit").click(function () {
        var txtVal = $("#venue-keyword").val();
        if (sVenueACHotelURL != '') { u = sVenueACHotelURL; sVenueACHotelURL = ''; }
        else {
            if (txtVal != "") { u = sVenueSearchURL + "?pst=" + escape(txtVal) + "&typ=HOT"; }
            else { u = sVenueSearchURL2 + "?typ=HOT"; }
        }          
        if (u != '') { winloc(u); }
    });
})

function appndVSrchParms(u) { 
    var url=u;
    if ($("#venue-guest-room").val() !="0") {url +="&rm=" + $("#venue-guest-room").val();}
    if ($("#venue-class").val() !="0") {url +="&cls=" + $("#venue-class").val();}           
    if ($("#venue-meeting-space").val() !="0") {url +="&mspc=" + $("#venue-meeting-space").val();}       
    if ($('#360-video-search').prop("checked")) {url +="&tst=1";}
    if (venue_search_chain_keys!="") {url +="&chns=" + venue_search_chain_keys;}
    return url;
 }

 var currentACRequest = null;  

jQuery.fn.initAutoSearch = function () {
    if (this.length == 0) { return }
    var args = arguments[0] || {}; var serviceURL = args.serviceURL; var searchURL = args.searchURL; var searchType = args.searchType; var parentselector = args.parentSelector; if (parentselector == "") { parentselector = "body" }

    var cache = {}; var txtbox = this.find("input:text")
    this.find("button[type='submit']").on("click",function (event) { doSearch(event); return false });
    txtbox.on("keydown",function (event) { if (event.keyCode == '13') { doSearch(event); return false } })
				  .autocomplete({
				      source: function (request, response) {

				          var Req = new Object(); Req.Term = request.term; Req.Context = searchType; var DTO = { 'Request': Req }; var json = JSON.stringify(DTO);
				          currentACRequest=$.ajax({
				              url: serviceURL + "/GetCompleteList", dataType: "json", type: "POST", contentType: "application/json; charset=utf-8", data: json,
				                beforeSend : function()    {           
								if(currentACRequest != null) {
									currentACRequest.abort();
									//console.log('abort');
								}
							},
							error: function () { 
														//console.log('ac error term:' + request.term)
								  response("") },
				              success: function (data) {
								//   console.log('ac success term:' + request.term)
				                  if (data.d) { data = data.d; }
				                  var resp = $.map(data, function (item) {
				                      if (item.key == 0) {
				                      }
                            if (item.Type == "X") { return null; }
                            else { return { label: item.Name, value: item.Data, url: item.URL, type: item.Type, src: searchType }; }
				                  });
				                  response(resp)
				              }
				          })
				      },				     
                      appendTo: parentselector, minLength: 3, delay: 0,
				      select: function (event, ui) {
				          if (ui.item.url != null) { var trk = ""; var trkt = "acg"; var c = ui.item.src; if (ui.item.type == "X") { trk = "&" + trkt + "acfm=1"; } trk = trkt + "=1" + trk; onACItemSelected(trk, ui.item.url, c, ui.item.value) }
				          else { return false; }
				      }
				  }).data("ui-autocomplete")._renderItem = function (ul, item) {
				      if (item.url == null) {
                var s = "<img src='/dist/images/ac/" + item.type + ".png?20180708'/>" + item.label
				          return $("<li class='ac-group'>").append(s).appendTo(ul);
				      } else {
				          return $("<li class='ac-item'>").append("<a>" + item.label + "</a>").appendTo(ul);
				      }

				  }

    function doSearch(event) { var txtVal = txtbox.val(); var u = ""; if (sVenueACHotelURL != '') { u = sVenueACHotelURL;  } else { if (txtVal != "") { u = sVenueSearchURL + "?pst=" + escape(txtVal) + "&typ=" + searchType; } else { u = sVenueSearchURL2 + "?typ=" + searchType; } }; if (u != '') { u = appndVSrchParms(u); winloc(u); } return false; }

    function onACItemSelected(t, u, c, v) { if (t != "") { u = appndURL(u, t); } sVenueACHotelURL = u; }

    function suptwinloc() { var b = true; if (/Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent)) { var ffversion = new Number(RegExp.$1); b = ffversion < 5; } return b; }

    function winloc(u) { if (!suptwinloc()) { window.location = u; return; } var a = document.createElement("a"); if (!a.click) { window.location = u; return; } a.setAttribute("href", u); a.style.display = "none"; document.body.appendChild(a); a.click(); }
};

!function (e, t) { "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : e.ShareThis = t() }(this, function () {
    "use strict"; function e(e) { var t = e.document.body, n = "static" === e.getComputedStyle(t).position ? t.parentNode : t; return n.getBoundingClientRect() } function t(e, t) { return h || (h = o(e)), e[h](t) } function n(e, n) { for (var r = e; r && (1 !== r.nodeType || !t(r, n)) ;) r = r.parentNode; return r } function r(e, t) { var n = e.compareDocumentPosition(t); return !n || (16 & n) > 0 } function o(e) { for (var t = "atchesSelector", n = ["matches", "m" + t, "webkitM" + t, "mozM" + t, "msM" + t, "oM" + t], r = 0; r < n.length; r++) { var o = n[r]; if (e[o]) return o } } function i(e, t) { for (var n = 0; n < e.length; n++) { var r = e[n]; if (r.name === t) return r } } function a(e, t) { if (t && "object" === ("undefined" == typeof t ? "undefined" : m(t))) for (var n in t) e[n] = t[n]; return e } function c(e) { return "function" == typeof e } function u(e) { if (Array.isArray(e)) { for (var t = 0, n = Array(e.length) ; t < e.length; t++) n[t] = e[t]; return n } return Array.from(e) } function f(e) { if (e.isCollapsed) return !0; var t = e.anchorNode.compareDocumentPosition(e.focusNode); return t ? (4 & t) > 0 : e.anchorOffset < e.focusOffset } function l(e, t) { var n = void 0, r = e.getClientRects(), o = [].slice.bind(r); if (t) { for (var i = 1 / 0, a = r.length; a--;) { var c = r[a]; if (c.left > i) break; i = c.left } n = o(a + 1) } else { for (var f = -(1 / 0), l = 0; l < r.length; l++) { var s = r[l]; if (s.right < f) break; f = s.right } n = o(0, l) } return { top: Math.min.apply(Math, u(n.map(function (e) { return e.top }))), bottom: Math.max.apply(Math, u(n.map(function (e) { return e.bottom }))), left: n[0].left, right: n[n.length - 1].right } } function s(e, t) { var o = e.cloneRange(); if (e.collapsed || !t) return o; var i = n(e.startContainer, t); return i ? r(i, e.endContainer) || o.setEnd(i, i.childNodes.length) : (i = n(e.endContainer, t), i ? o.setStart(i, 0) : o.collapse()), o } function d(t, n, r) { var o = r.document, i = o.defaultView, a = i.getSelection(), c = f(a), u = l(n, c), s = e(i), d = t.style; c ? d.right = o.documentElement.clientWidth - u.right + s.left + "px" : d.left = u.left - s.left + "px", d.width = u.right - u.left + "px", d.height = u.bottom - u.top + "px", d.top = u.top - s.top + "px", d.position = "absolute", t.className = r.popoverClass } function p(e, t) { var r = n(t.target, "[" + g + "]"); if (r) { var o = r.getAttribute(g), a = i(e, o); a && c(a.action) && a.action(t, r) } } function v(e) { return { createPopover: function () { var t = e.createElement("div"); return t.addEventListener("click", function (e) { p(this.sharers, e) }), t }, attachPopover: function (t) { e.body.appendChild(t) }, removePopover: function (e) { var t = e.parentNode; t && t.removeChild(e) } } } var h = void 0, m = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) { return typeof e } : function (e) { return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e }, g = "data-share-via", y = function (e, t, n, r) { var o = e.shareUrl || e.document.defaultView.location; return "<ul>" + t.map(function (e) { return '<li data-share-via="' + e.name + '">' + e.render.call(e, n, r, o + (o.toString().indexOf("?") > 0 ? "&" : "?") + "src=" + e.name) + "</li>" }).join("") + "</ul>" }, b = void 0, C = ["selectionchange", "mouseup", "touchend", "touchcancel"], S = function (e) {
        function t(e) { g.addEventListener(e, o) } function n(e) { g.removeEventListener(e, o) } function r() { E && d(E, i(), p) } function o(e) { var t = e.type, n = "selectionchange" === t; !E !== n && setTimeout(function () { var e = i(); e ? u(e) : f() }, 10) } function i() { var e = S.getSelection(), t = e.rangeCount && e.getRangeAt(0); if (t) { var n = s(t, p.selector); if (!n.collapsed && n.getClientRects().length) return n } } function u(e) {
            var t = !E
            , n = e.toString(), r = p.transformer(n), o = p.sharers.filter(l.bind(null, r, n)); return o.length ? (t && (E = M.createPopover()), E.sharers = o, E.innerHTML = y(p, o, r, n), d(E, e, p), void (t && (M.attachPopover(E), c(p.onOpen) && p.onOpen(E, r, n)))) : void (E && f())
        } function f() { E && (M.removePopover(E), E = b, c(p.onClose) && p.onClose()) } function l(e, t, n) { var r = n.active; return c(r) ? r(e, t) : r === b || r } var p = (Object.assign || a)({ document: document, selector: "body", sharers: [], popoverClass: "share-this-popover", transformer: function (e) { return e.trim().replace(/\s+/g, " ") } }, e || {}), h = !1, m = !1, g = b, S = b, E = b, M = b; return { init: function () { return !h && (g = p.document, S = g.defaultView, S.getSelection ? (C.forEach(t), S.addEventListener("resize", r), M = v(g), h = !0) : (console.warn("share-this: Selection API isn't supported"), !1)) }, destroy: function () { return !(!h || m) && (C.forEach(n), S.removeEventListener("resize", r), f(), g = b, S = b, m = !0) } }
    }; return S
});

!function (e, o) { "object" == typeof exports && "undefined" != typeof module ? o(exports) : "function" == typeof define && define.amd ? define(["exports"], o) : o(e.ShareThisViaFacebook = e.ShareThisViaFacebook || {}) }(this, function (e) { "use strict"; function o(e, o, n) { return '<a href="' + this.getShareUrl(e, n) + '" target="_blank" rel="noopener nofollow noreferrer"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-facebook"></use></svg></a>' } function n(e, o) { var st = $(".facebook-share").attr("_ShareURL"); if (st != "") { o = st; } return "https://www.facebook.com/sharer/sharer.php?quote=" + encodeURIComponent(e) + "&u=" + encodeURIComponent(o) } function t(e, o) { e.preventDefault(), o.ownerDocument.defaultView.open(o.firstChild.href, "share_via_facebook", "height=440,location=no,menubar=no,scrollbars=no,status=no,toolbar=no,width=640").opener = null } e.render = o, e.getShareUrl = n, e.action = t, e.name = "facebook", Object.defineProperty(e, "__esModule", { value: !0 }) });

!function (e, n) { "object" == typeof exports && "undefined" != typeof module ? n(exports) : "function" == typeof define && define.amd ? define(["exports"], n) : n(e.ShareThisViaLinkedIn = e.ShareThisViaLinkedIn || {}) }(this, function (e) { "use strict"; function n(e, n, t) { var r = this.getText(e); return '<a href="' + this.getShareUrl(r, t) + '" target="_blank" rel="noopener nofollow noreferrer"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-linkedin"></use></svg></a>' } function t(e) { var n = e.trim(); return n.length > i - 2 && (n = n.slice(0, i - 3).trim() + "â€¦"), "â€œ" + n + "â€" } function r(e, n) { var st = $(".linked-in-share").attr("_ShareURL"); if (st != "") { n = st; } return "https://www.linkedin.com/shareArticle?mini=true&summary=" + encodeURIComponent(e) + "&url=" + encodeURIComponent(n) } function o(e, n) { e.preventDefault(), n.ownerDocument.defaultView.open(n.firstChild.href, "share_via_linked_in", "height=440,location=no,menubar=no,scrollbars=no,status=no,toolbar=no,width=640").opener = null } var i = 250; e.render = n, e.getText = t, e.getShareUrl = r, e.action = o, e.name = "linked-in", Object.defineProperty(e, "__esModule", { value: !0 }) });

!function (e, t) { "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t(e.ShareThisViaTwitter = e.ShareThisViaTwitter || {}) }(this, function (e) { "use strict"; function t(e, t, n) { var r = this.getText(e); return '<a href="' + this.getShareUrl(r, n) + '" target="_blank" rel="noopener nofollow noreferrer"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-twitter"></use></svg></a>' } function n(e) { var t = e.trim(); return t.length > i - 2 && (t = t.slice(0, i - 3).trim() + "â€¦"), "â€œ" + t + "â€" } function r(e, t) { var st = $(".twitter-share").attr("_ShareURL"); if (st != "") { t = st; } return "https://twitter.com/intent/tweet?via=TravelAgeWest&text=" + encodeURIComponent(e) + "&url=" + encodeURIComponent(t) } function o(e, t) { e.preventDefault(), t.ownerDocument.defaultView.open(t.firstChild.href, "share_via_twitter", "height=440,location=no,menubar=no,scrollbars=no,status=no,toolbar=no,width=640").opener = null } var i = 120; e.render = t, e.getText = n, e.getShareUrl = r, e.action = o, e.name = "twitter", Object.defineProperty(e, "__esModule", { value: !0 }) });

$.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(function () {
    ShareThis({
        selector: '.article p',
        sharers: [window.ShareThisViaFacebook, window.ShareThisViaTwitter, window.ShareThisViaLinkedIn]
    }).init();

    // bind to all "social links" so that they open in a dialog
    initSocialShares()

    initListicle();
});

function initListicle() {
    if ($(".listicle").length==0){return}

    $(window).scroll(function () {
        var id = ""
        $('.listicle').each(function (i, obj) {
            if ($(this).isInViewport()) {  //find each post in viewport. 
                id = $(this).find(".listicle-bk").attr("id"); //get the last
            }
        });
        if (id == undefined) { id = ""; }
        if (id != "") { id = "#" + id }
        if (window.location.hash != id) {
            if (id == "") {
                history.pushState(null, null, window.location.pathname);
            } else { history.pushState(null, null, id); }
        }
    });
}

function initSocialShares() {
    $('a[data-share-dialog]').on('click touch', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        try { gaEvent("Social Sharing", $(this).attr("aria-label"), $(this).attr("_pgk")) } catch (ex) { }
        this.ownerDocument.defaultView.open(
            this.href,
            "share",
            "height=440,location=no,menubar=no,scrollbars=no,status=no,toolbar=no,width=640"
        );
    });
}

function validatecmp() {
    var ids = "";
    var n = 0;
    $(".ven-cmp").find(".form-check").find("input").map(function () {
        if ($(this).prop("checked")) { n++; ids += $(this).val() + "|" }
    })
    if (n <= 1) {
        alert('Please select 2 or more venues to compare')
        return "";
    } else {
        return ids;
    }
}

function AddVenueToCompare(id) {
    var DTO = { 'id': id }
    DynaProxy.invoke("AddVenueToCompare", DTO, function (data) {
        $(".ven-cmp").html(data).attr("_loaded", "1")
        $("#venueComparisonModal").modal('show')
    }, AjaxFailed);
}

function RemoveVenueToCompare(id) {
    var DTO = { 'id': id }
    DynaProxy.invoke("RemoveVenueToCompare", DTO, function (data) {
        $(".ven-cmp").html(data).attr("_loaded", "1");
        if ($('.scroll-table.venue-compare').length > 0) { window.location = location.href.replace(id + "|", ''); return false }
    }, AjaxFailed);
}

function ClearVenueToCompare() {
    var DTO = {}
    DynaProxy.invoke("ClearVenueToCompare", DTO, function (data) { $('.cmp-count').html("0"); window.location.reload();  }, AjaxFailed);        
}

function invokecmpgate(ids) {
    if (ids != "") {
        var url = "/Meeting-Event-Venues/Search/?cmp=1&selo=1&selp=" + ids;
        $("#signupModal2").find("iframe").attr("src", "/user/widgets/register/?returl=" + escape(url))
        $(".gated-compare-login").attr("href", "/User/Login/?returl=" + escape(url));
        $("#venueComparisonModal").modal("hide")
        $('#gatedcompare').modal('show');
    }
}
    
$.urlParam = function(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results=== null)
    {
	    return "" ;
    }
    else{ return results[1];}
}

$(function () {
		if ($.urlParam('cmp') == 1) {
        if ($(".ven-cmp").attr("_loaded") != "1") {
            DynaProxy.invoke("GetCompareVenues", {}, function (data) {
                $(".ven-cmp").html(data).attr("_loaded", "1")
            }, AjaxFailed);
        }
    }
    $('#venueComparisonModal').on('show.bs.modal', function () {
        if ($(".ven-cmp").attr("_loaded") != "1") {
            DynaProxy.invoke("GetCompareVenues", {}, function (data) {
                $(".ven-cmp").html(data).attr("_loaded", "1")
            }, AjaxFailed);
        }
    })

    $(document).on("click", ".cmp-venue", function () {
        var id = $(this).attr("_id");
        AddVenueToCompare(id)
        return false;
    })
    
    $(document).on("click", ".btn-cmp-remove", function () {
        if ($(".ven-cmp").find(".form-check").length <= 2)
        {
            alert('Please select another venue for comparison before deleting one of the remaining two.');
            return false;
        }
        var id = $(this).attr("_id");
        RemoveVenueToCompare(id)
        return false;
    })
    
    $(document).on("click", ".ven-gate-cmp", function () {
        invokecmpgate(validatecmp())
        return false;
    })
    
    $(document).on("click", ".gated-compare-register", function () {
        $('#gatedcompare').on('hidden.bs.modal', function (e) {$('#signupModal2').modal('show');})          
        $('#gatedcompare').modal('hide');
        return false;
    })
    
    $(document).on("click", ".clear-vue-cmp", function () {            
        ClearVenueToCompare();
        return false;
    })
   
    $(document).on("click", ".ven-do-cmp", function () {
        var ids = validatecmp();
        if (ids!=""){
            var url = "/Meeting-Event-Venues/Search?cmp=1&selo=1&selp=" + ids
            window.location = url
        }
        return false;
    })
});



$(function () {
          
    $(document).on("click", ".dismiss-continue", function () {
        var up = window.location.pathname;
        var bVue = up.toLowerCase().indexOf('/meeting-event-venues') >= 0 ||
            up.toLowerCase().indexOf('/meeting-facilities') >= 0;
            
        if ($(".page-venue-detail").length > 0) bVue = false;
        if ($("article.listicle").length > 0) bVue = true;
        if ((up.toLowerCase().indexOf('/destinations/')>=0 ||(up.toLowerCase().indexOf('/destination-guides/')>=0)) && $('.featured-venues').length > 0) bVue = true;
            
        if (!bVue) { winloc("/Meeting-Event-Venues"); }
    });

});


//fix ios 11 input in model
$(function () {
    var ua = navigator.userAgent, ios = /iPad|iPhone|iPod/.test(ua), ios11 = /OS 11_0|OS 11_1|OS 11_2/.test(ua);
    if (ios && ios11) { $("body").addClass("iosBugFixCaret"); }
});

//event landing page 3 times access
function setCookie(cookieName, cookieValue, nDays) {
    var today = new Date(),
        expire = new Date();

    if (nDays === null || nDays === 0) {
        nDays = 1;
    }

    expire.setTime(today.getTime() + 3600000 * 24 * nDays);

    document.cookie = cookieName + "=" + escape(cookieValue) + ";expires=" + expire.toGMTString();
};

function getCookie(cookieName) {
    var theCookie = " " + document.cookie,
        ind = theCookie.indexOf(" " + cookieName + "=");

    if (ind === -1) { ind = theCookie.indexOf(";" + cookieName + "="); }
    if (ind === -1 || cookieName === "") { return ""; }

    var ind1 = theCookie.indexOf(";", ind + 1);

    if (ind1 === -1) { ind1 = theCookie.length; }

    return unescape(theCookie.substring(ind + cookieName.length + 2, ind1));
};

function CheckUserVisits() {
    var path = window.location.pathname;
    var isLoggedIn = $(".find-venue-hero-form").attr("_lg");
    var isRedirect = true;
    $(document).on("click", ".gated-EventVenue-register", function () {
        isRedirect = false;
    });
    
    $("#gatedEventVenues").on("hidden.bs.modal",
        function() {    
        if (isRedirect) {
            window.location = "About-Us";
        }
        $('#signupModal2').on('hidden.bs.modal', function () {
            window.location = "About-Us";
        });
    });
    // Commented out for NGN-925 - remove gating
    //if ((path.toLowerCase() === "/meeting-event-venues") && typeof isLoggedIn === "undefined") {
    //    var numLoads = parseInt(getCookie('EVvisit'), 10);

    //    if (isNaN(numLoads) || numLoads <= 0) { setCookie('EVvisit', 1,3650); }
    //    else { setCookie('EVvisit', numLoads + 1); }
    //    //var loaded_numb = 3;
    //    if (getCookie('EVvisit') > 3) {
    //        //if user is not logged in, show alert
    //        invokeEventVenuesGate();
    //    }
    //}
};

function SalarySurveyGate() {
    var path = window.location.pathname;
    var isLoggedIn = $("#gatedSalarySurvey").attr("_lg");
    var isRedirect = true;
    $(document).on("click", ".gated-SalarySurvey-register", function () {
        isRedirect = false;
    });
    $("#gatedSalarySurvey").on("hidden.bs.modal",
        function () {
            if (isRedirect) {
                window.location = "About-Us";
            }
            $('#signupModal2').on('hidden.bs.modal', function () {
                window.location = "About-Us";
            });
        });
    if ((path.toLowerCase() === "/salary-survey") && typeof isLoggedIn === "undefined") {
        invokeSalarySurveyGate();
    }
};

function invodeGatedSite(cID) {
    var isRedirect = true;
    var url = window.location.pathname;
    var loginredirecturl = document.reffer;
    if (loginredirecturl == undefined) { loginredirecturl = "/home"; }
    $(".gated-site-login").attr("href", "/User/Login/?returl=" + escape(url));
    $('#gatedSite').modal('show');
    $(document).on("click", ".gated-site-register", function () {
        var isSpsr = ""
        var spsrId = ""
        if ($('.divSprId').html().length != 0) { spsrId = "&sponsor=" + $('.divSprId').html(); }
        if ($('.divSpr').html() == "SPR") { isSpsr = "&type=SPR"; }
        if ($('.divSpr').html() == "WBN") { isSpsr = "&type=WBN"; }
        if (cID.length != 0) { cID = "&cID=" + cID }
        $("#signupModal2").find("iframe").attr("src", "/user/widgets/register/?returl=" + escape(url) + isSpsr + spsrId + cID)
        $('#signupModal2').find('iframe').css('height', '1250px');
        $('#gatedSite').on('hidden.bs.modal', function (e) { $('#signupModal2').modal('show');  })
        $('#gatedSite').modal('hide');
        isRedirect = false;
        return false;
    })

    $("#signupModal2").on("hidden.bs.modal", function () {
        if ($("iframe").contents().find("#Button_TravelBack").length == 0) {
            window.location = loginredirecturl;
        }
        else { window.location = url;}
    })

    $("#gatedSite").on("hidden.bs.modal", function () {
        if (isRedirect) { window.location = loginredirecturl; }
    })
}

$('#video-search-checkbox').click(function () {
    $('#video-search-checkbox').toggle();
    $('#video-search-checkbox-unchecked').toggle();
    $('#360-video-search').prop("checked", false);
});

$('#video-search-checkbox-unchecked').click(function () {
    $('#video-search-checkbox').toggle();
    $('#video-search-checkbox-unchecked').toggle();
    $('#360-video-search').prop("checked", true);
});

$(document).on("click", ".btn-RegNewsletter", function () {
    var elePar = $(this).parents(".newsletter-register-form")
   
    var opts = ""; var desc = ""; var nameFirst = ""; var nameLast = ""; var email = "";
    var country = ""; var state = ""; var plannerType = ""; var terms = "";

    if (elePar.find("#NameFirst").length > 0) { nameFirst = elePar.find("#NameFirst").val(); }
    if (nameFirst == "") {
        elePar.find(".error").html("Please enter your first name.").show();
        return false;
    }

    if (elePar.find("#NameLast").length > 0) { nameLast = elePar.find("#NameLast").val(); }
    if (nameLast == "") {
        elePar.find(".error").html("Please enter your last name.").show();
        return false;
    }
    if (elePar.find("#SmtID").length > 0) { email = elePar.find("#SmtID").val(); }
    if (email == "") {
        elePar.find(".error").html("Please enter your email address.").show();
        return false;
    }
 
    if (!validateEmail(email)) {
        elePar.find(".error").html("Please enter a valid email address.").show();
        return false;
    }

    if (elePar.find("#CompanyCountry").length > 0) { country = elePar.find("#CompanyCountry").val(); }
    if (country == "") {
        elePar.find(".error").html("Please select your country.").show();
        return false;
    }

    if (elePar.find("#CompanyState").length > 0) { state = elePar.find("#CompanyState").val(); }
    if (state == "") {
        elePar.find(".error").html("Please select your state.").show();
        return false;
    }
     
    if (elePar.find("#PrimaryBusiness").length > 0) {
        plannerType = elePar.find("#PrimaryBusiness").val();
    }
    if (plannerType == "") {
        elePar.find(".error").html("Please select your Planner Type.").show();
        return false;
    }

    if (elePar.find(".form-copy").find("*:checkbox").length> 0) {
        if( elePar.find(".form-copy").find("*:checkbox:checked").length==0)
        {
            elePar.find(".error").html("Please agree with the terms and privacy policy.").show();
            return false;
        }
    }

    if (elePar.find("#pnlInfo").find("*:checkbox").length > 0) {
        elePar.find("#pnlInfo").find("*:checkbox:checked").map(function () {
            desc = desc + $(this).attr("id") + "<br/>"
            opts = opts + $(this).val() + "|"
        })
        if (opts == '') {
            elePar.find(".error").html("Please select one or more newsletters to subscribe to.").show();
            return false;
        }
    }

    showNewsletterOptin(email, opts, country, desc, plannerType, nameFirst, nameLast, state, window.location,"newsletterreg")
})